import { useOnboardingContext } from '@/contexts/onboardingContext';
import useMixpanel from '@/hooks/useTracking/useMixpanel';
import Label from '@/ui/members/components/form/Label';
import { focusClasses } from '@/ui/members/components/form/styles';

import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Checkbox = ({ checked, id, label, onChange, required }: Props) => {
  const mixpanel = useMixpanel();
  const context = useOnboardingContext();

  const onChangeWithTrack = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event);
    mixpanel.trackCheckboxClicked(id, event.target.checked, undefined, {
      version: context.version,
      feature: 'unified-onboarding'
    });
  };

  return (
    <div className="flex items-start mb-4">
      <input
        className={`h-5 w-5 mr-4 mt-0.5 accent-uniform-gray-600 ${focusClasses}`}
        checked={checked}
        type="checkbox"
        id={id}
        onChange={(event) => onChangeWithTrack(event)}
        required={required}
      />
      <Label htmlFor={id} noMargin text={label} />
    </div>
  );
};

export default Checkbox;
